<template>
  <div>Tools works !</div>
</template>

<script>
export default {
  name: 'Tools',
}
</script>

<style>

</style>
